import React, { useRef } from 'react';
import Filter from 'components/core/Filter';
import DateField from 'components/core/DateField';

const DateFilter = ({ showOperator, operator, dataType, onChange, ...others }) => {
    const operators = useRef([
        // { label: 'equal', value: 'eq' },
        { label: 'greater than', value: 'gt' },
        { label: 'less than', value: 'lt' }
        // { label: 'between', value: 'btw' }    
    ])

    return (
        <Filter
            component={DateField}
            operator={(showOperator && operator) ? operator : "gt"}
            operators={showOperator && operators.current}
            showOperator={showOperator}
            dataType={dataType}
            onChange={onChange}
            variant={"inline"}
            {...others}
        />
    )
}

export default DateFilter